export default{skeletonText:"w_DC",skeleton:"w_DD"};
